import React, { useCallback, useEffect, useMemo, useState } from 'react';
import PageContainer from '../../../shared/layout/containers/PageContainer';
import PageHeader from '../../../shared/layout/headers/PageHeader';
import PageTitle from '../../../shared/layout/titles/PageTitle';
import PageContent from '../../../shared/layout/containers/PageContent';
import MainButton from '../../../shared/layout/buttons/MainButton';
import { fetchAdminFreshness } from '../../../services/Http/AdminApi';
import AdminFilterBar from './components/AdminFilterBar';
import AdminDataTable from './components/AdminDataTable';
import FreshnessBadge from './components/FreshnessBadge';
import MetricTrustBadge from './components/MetricTrustBadge';
import { toast } from 'react-toastify';

const AdminFreshness = () => {
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);

    const load = useCallback(async () => {
        setLoading(true);
        try {
            const response = await fetchAdminFreshness();
            setRows(response?.data || []);
        } catch (error) {
            toast.error(error?.response?.data?.message || 'Failed to load freshness');
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        load();
    }, [load]);

    const columns = useMemo(() => ([
        { key: 'domain', label: 'Domain' },
        { key: 'status', label: 'Status', render: (row) => <FreshnessBadge status={row.status} sourceType={row.source_type} /> },
        { key: 'trust', label: 'Trust', render: () => <MetricTrustBadge tier="derived" /> },
        {
            key: 'last_success_at',
            label: 'Last Success',
            render: (row) => row.last_success_at ? new Date(row.last_success_at).toLocaleString() : '—',
        },
        {
            key: 'refresh_lag_seconds',
            label: 'Lag',
            render: (row) => row.refresh_lag_seconds == null ? '—' : `${Math.round(row.refresh_lag_seconds / 60)} min`,
        },
        { key: 'last_error', label: 'Last Error', render: (row) => row.last_error || '—' },
    ]), []);

    return (
        <PageContainer>
            <PageHeader>
                <PageTitle>Summary Freshness</PageTitle>
            </PageHeader>
            <PageContent>
                <AdminFilterBar>
                    <div>Derived analytics freshness and latest refresh status</div>
                    <MainButton size="small" onClick={load}>Refresh</MainButton>
                </AdminFilterBar>
                <AdminDataTable columns={columns} rows={rows} loading={loading} emptyText="No freshness records" />
            </PageContent>
        </PageContainer>
    );
};

export default AdminFreshness;
